import { create } from 'zustand';
import { api, type TenantRuntimeConfig } from '@/services/api';

const PRODUCT_FALLBACK = 'TelcoOS';

export interface RuntimeConfigState {
  config: TenantRuntimeConfig | null;
  initialized: boolean;
  isLoading: boolean;
  error: string | null;
  loadRuntimeConfig: () => Promise<void>;
}

export const useRuntimeConfigStore = create<RuntimeConfigState>((set, get) => ({
  config: null,
  initialized: false,
  isLoading: false,
  error: null,

  loadRuntimeConfig: async () => {
    if (get().isLoading || get().initialized) return;

    set({ isLoading: true, error: null });

    try {
      const config = await api.system.getRuntimeConfig();
      set({
        config,
        initialized: true,
        isLoading: false,
        error: null,
      });
    } catch (err) {
      set({
        config: null,
        initialized: true,
        isLoading: false,
        error: err instanceof Error ? err.message : 'Failed to load runtime config',
      });
    }
  },
}));

export function getProductName(config: TenantRuntimeConfig | null): string {
  return config?.product.name?.trim() || PRODUCT_FALLBACK;
}

export function getCustomerName(config: TenantRuntimeConfig | null): string | null {
  const customerName = config?.customer.name?.trim();
  const tenantName = config?.tenant.name?.trim();

  return customerName || tenantName || null;
}

export function getCobrandName(config: TenantRuntimeConfig | null): string {
  const productName = getProductName(config);
  const customerName = getCustomerName(config);

  if (!customerName || customerName.toLowerCase() === productName.toLowerCase()) {
    return productName;
  }

  return `${customerName} | ${productName}`;
}
